const $ = window.jQuery;
import Splide from "@splidejs/splide";

$(function () {
	var values = $(".aka-block-faq-tabs");

	let tab_nav = document.querySelectorAll(".tab-nav-inner");
	if (tab_nav.length > 0) {
		for (let i = 0; i < tab_nav.length; i++) {
			let tab_navElement = tab_nav[i];
			let tab_navDefaultOptions = {
				type: "slide",
				arrows: false,
				pagination: false,
				autoWidth: true,
				trimSpace: "move",
				focus: "center",
			};
			let items = new Splide(tab_navElement, tab_navDefaultOptions);
			items.mount();
		}
	}

	let _icons = document.querySelectorAll(".icon-content-wrapper");
	if (_icons.length > 0) {
		for (let i = 0; i < _icons.length; i++) {
			let _iconsElement = _icons[i];
			let _iconsDefaultOptions = {
				type: "slide",
				arrows: false,
				rewind: true,
				pagination: false,
				autoWidth: true,
			};
			let items_icons = new Splide(_iconsElement, _iconsDefaultOptions);
			items_icons.mount();
		}
	}

	if (values.length) {
		$(".accordion-tab-content .accordion-item").css("display", "none");
		$(".accordion-tab-content .accordion-item:first-of-type").css("display", "block");

		$(".aka-block-faq-tabs .splide__slide .item").on("click", function (e) {
			e.preventDefault();

			var valueName = $(this).attr("data-id");

			$(".accordion-tab-content .accordion-item").css("display", "none");
			$(`.accordion-tab-content #${valueName}.accordion-item`).css("display", "block");

			if ($(this).parent().hasClass("tab-selected")) {
				$(this).parent().removeClass("tab-selected");
			} else {
				$(".aka-block-faq-tabs .splide__slide").removeClass("tab-selected");
				$(this).parent().addClass("tab-selected");
			}
		});
	}
});
